import React from "react";
import { Link, useParams } from "react-router-dom";
import { Button, Divider } from "@mui/material";
import { toast } from "react-toastify";
import { EditOutlined } from "@mui/icons-material";

import {
  WarehouseDetailContext,
  useWarehouseDetailContext,
} from "contexts/WarehouseDetailContext";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import WarehouseBasicDetail from "./warehouseComponents/WarehouseBasicDetail";
import EnableDisableButton from "components/Shared/EnableDisableButton";

import {
  useGetWarehouseDetailQuery,
  useUpdateWarehouseMutation,
} from "store/services/warehouseApi";

import { useAppMeta } from "hooks";
import ShipmentInWarehouseList from "./warehouseComponents/ShipmentsInWarehouseList";

const WarehouseDetailScreen = () => {
  const { id } = useParams();

  const breadcrumbs = [
    { title: "Warehouses", path: "/app/crm/warehouse/list" },
    { title: "Warehouse Detail" },
  ];

  // RTK Query
  const {
    data: warehouseDetail,
    isLoading: loadingWarehouse,
    error,
  } = useGetWarehouseDetailQuery(id);

  useAppMeta("Warehouse Detail");

  return (
    <WarehouseDetailContext.Provider value={{ warehouseDetail, loadingWarehouse }}>
      <BreadcrumbLayout
        breadcrumbs={breadcrumbs}
        isBusy={loadingWarehouse}
        toggleKey="WAREHOUSE_DETAIL"
        headerActions={<PageActions />}
      >
        <BreadcrumbLayout.Error error={error} />

        <BreadcrumbLayout.Paper>
          <WarehouseBasicDetail />
          <Divider />
          <ShipmentInWarehouseList
/>
        </BreadcrumbLayout.Paper>
      </BreadcrumbLayout>
    </WarehouseDetailContext.Provider>
  );
};

export default WarehouseDetailScreen;

const PageActions = () => {
  const { warehouseDetail, loadingWarehouse } = useWarehouseDetailContext();

  // RTK Query
  const [updateWarehouse, { isLoading: updatingWarehouse }] =
    useUpdateWarehouseMutation();

  // methods
  const handleToggleWarehouseStatus = async () => {
    try {
      const updatedStatus = !warehouseDetail?.operational_status;

      await updateWarehouse({
        _id: warehouseDetail?._id, 
        operational_status: updatedStatus,
      }).unwrap();

      toast.info(
        `Warehouse successfully ${updatedStatus ? "Enabled" : "Disabled"}!`
      );
    } catch (err) {
      toast.error(err?.data?.message ?? "Couldn't update Warehouse Status!");
      
    }

  };

  return (
    <div className="flex items-center gap-4">
      <EnableDisableButton
        isActive={warehouseDetail?.operational_status} // Updated prop to match operational_status
        loading={loadingWarehouse || updatingWarehouse}
        onClick={handleToggleWarehouseStatus}
      />

      <Link to={`/app/crm/warehouse/${warehouseDetail?._id}/edit`}>
        <Button startIcon={<EditOutlined />} variant="contained">
          Edit
        </Button>
      </Link>
    </div>
  );
};
